
     <form [formGroup]="formEdit" >
      <mat-dialog-content>
        <mat-form-field>
          <mat-label i18n="@@datadialog.date">Wybierz datę</mat-label>
          <input matInput [matDatepicker]="picker" formControlName="content" autocomplete="off">
          <mat-datepicker-toggle matSuffix [for]="picker">
          </mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
      </mat-dialog-content>
      <mat-dialog-actions align="end">
        <button mat-raised-button  (click)="save()">OK</button>
      </mat-dialog-actions>
    </form>
  